("use strict");

console.log("hello");

document.addEventListener("DOMContentLoaded", function() {
  // мобильное меню
  let iconMenu = document.querySelector(".menu__icon");
  let menuBody = document.querySelector(".mobile__menu");
  let navLinks = document.querySelectorAll(".nav__link");
  let navLogo = document.querySelector(".header__logo");
  let navLangs = document.querySelectorAll(".lang__item");

  if (iconMenu) {
    iconMenu.addEventListener("click", function(event) {
      event.preventDefault();
      document.body.classList.toggle("_lock");
      iconMenu.classList.toggle("_active");
      menuBody.classList.toggle("mobile__menu_mob");
      iconMenu.classList.toggle("menu__icon_mob");
      navLogo.classList.toggle("header__logo_mob");
      navLangs.forEach(navLang => navLang.classList.toggle("lang__item_mob"));
    });
  }

  if (navLinks) {
    navLinks.forEach((navLink) => {
      navLink.addEventListener("click", function(e) {
        document.body.classList.remove("_lock");
        iconMenu.classList.remove("_active");
        menuBody.classList.remove("mobile__menu_mob");
        iconMenu.classList.remove("menu__icon_mob");
        navLogo.classList.remove("header__logo_mob");
        navLangs.forEach(navLang => navLang.classList.remove("lang__item_mob"));
      });
    });
  }

  if (jQuery(".cusslider-ph").length > 0) {
    jQuery(".cusslider-ph").on("afterChange init", function(event, slick, direction) {
        // console.log("afterChange/init", event, slick, slick.$slides);
        // remove all prev/next
        slick.$slides.removeClass("prev-slide").removeClass("next-slide");
        lazyLoadInstance.update()

        // find current slide
        for (var i = 0; i < slick.$slides.length; i++) {
          var $slide = jQuery(slick.$slides[i]);
          var $nextSlide = jQuery(slick.$slides[i + 1]);
          if ($slide.hasClass("slick-active") && !$nextSlide.hasClass('slick-active')) {
            // update DOM siblings
            $slide.prev().addClass("prev-slide");
            $slide.next().addClass("next-slide");
            $slide.next().removeClass("slick-loading");
            let img = $slide.next().find('img').first()
            let src = img.data('lazy')
            img.attr('src', src)
            break;
          }
        }
      }
    )
      .on("beforeChange", function(event, slick) {
        slick.$slides.removeClass("prev-slide").removeClass("next-slide");
        lazyLoadInstance.update()
      }).slick({
          lazyLoad: "ondemand",
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          speed: 800,
          variableWidth: true,
          arrows: true,
          prevArrow: `<div class="slider_prew slider_arrow"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="2.54545" height="14" rx="1.27273" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 10.8984 19.7991)" fill="#FF46C0"/>
              <rect width="2.66667" height="13.3636" rx="1.33333" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 12.7832 1.8858)" fill="#FF46C0"/>
              </svg> </div>`,
          nextArrow: `<div class="slider_next slider_arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="9.89844" y="19.7991" width="2.54545" height="14" rx="1.27273" transform="rotate(-135 9.89844 19.7991)" fill="#FF46C0"/>
              <rect x="8.01367" y="1.8858" width="2.66667" height="13.3636" rx="1.33333" transform="rotate(-45 8.01367 1.8858)" fill="#FF46C0"/>
              </svg></div>`,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            }
          ]
    });
  }

  if (jQuery(".cusslider-rev").length > 0) {
    jQuery(".cusslider-rev").on("afterChange init", function(event, slick, direction) {
        // console.log("afterChange/init", event, slick, slick.$slides);
        // remove all prev/next
        slick.$slides.removeClass("prev-slide").removeClass("next-slide");
        lazyLoadInstance.update()

        // find current slide
        for (var i = 0; i < slick.$slides.length; i++) {
          var $slide = jQuery(slick.$slides[i]);
          var $nextSlide = jQuery(slick.$slides[i + 1]);
          if ($slide.hasClass("slick-active") && !$nextSlide.hasClass('slick-active')) {
            // update DOM siblings
            $slide.prev().addClass("prev-slide");
            $slide.next().addClass("next-slide");
            $slide.next().removeClass("slick-loading");
            let img = $slide.next().find('img').first()
            let src = img.data('lazy')
            img.attr('src', src)
            break;
          }
        }
      }
    )
      .on("beforeChange", function(event, slick) {
        slick.$slides.removeClass("prev-slide").removeClass("next-slide");
        lazyLoadInstance.update()
      }).slick({
      lazyLoad: "ondemand",
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      speed: 800,
      variableWidth: true,
      arrows: true,
      prevArrow: `<div class="slider_prew slider_arrow"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="2.54545" height="14" rx="1.27273" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 10.8984 19.7991)" fill="#FF46C0"/>
              <rect width="2.66667" height="13.3636" rx="1.33333" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 12.7832 1.8858)" fill="#FF46C0"/>
              </svg> </div>`,
      nextArrow: `<div class="slider_next slider_arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="9.89844" y="19.7991" width="2.54545" height="14" rx="1.27273" transform="rotate(-135 9.89844 19.7991)" fill="#FF46C0"/>
              <rect x="8.01367" y="1.8858" width="2.66667" height="13.3636" rx="1.33333" transform="rotate(-45 8.01367 1.8858)" fill="#FF46C0"/>
              </svg></div>`,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }).magnificPopup({
      type: 'image',
      delegate: 'a',
      gallery: {
        enabled: true,
      },
    })
  }

  jQuery('.paig__plan.plan .mfp-popup').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true,
    },
  });

  jQuery('.paig__plan.diplomas .mfp-popup-diploms').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true,
    },
  });
});


//сдайлер "відгуки до/після"

// const images = document.querySelectorAll('.gallery .gallery__line img');
// const sliderLine = document.querySelector('.gallery__line');
// let count = 0;
// let width;

// function init() {
//   console.log('resize');
//   width = document.querySelector('.gallery').offsetWidth;
//   sliderLine.style.width = width * images.length + 'px';
//   images.forEach(item => {
//     item.style.width = width + 'px';
//   });

//   console.log(width);
// };

// window.addEventListener('resize', init);
// init();

// document.


